import React from 'react';

import { useFlexLayout, useSortBy, useTable } from 'react-table';

import './table.scss';

import classnames from 'classnames';

function fixColumns(columns) {
	columns.map((column) => {
		if (column.columns) {
			column.columns = fixColumns(column.columns);
		}

		if (!column.sort) {
			column.disableSortBy = true;
		}
	});

	return columns;
}

function Table({ columns, data, initialState }) {
	//	columns = React.useMemo(columns);
	//	data = React.useMemo(data);

	columns = fixColumns(columns);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable(
			{
				columns,
				data,
				initialState,
			},
			useFlexLayout,
			useSortBy
		);

	// Render the UI for your table
	return (
		<div style={{ maxWidth: '100%', overflow: 'auto' }}>
			<table
				{...getTableProps()}
				className='table table-striped table-bordered dm-react-table'
			>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => {
								return (
									<th {...column.getHeaderProps(column.getSortByToggleProps())}>
										<div
											className={classnames('text-' + column.headerAlign)}
											onClick={() => {
												!!column.onSort && column.onSort(column);
											}}
										>
											{column.render('Header')}
											<span>
												{!column.disableSortBy && (
													<span
														className={classnames(
															'show-sort-arrows',
															column.isSorted
																? column.isSortedDesc
																	? 'desc'
																	: 'asc'
																: ''
														)}
													></span>
												)}
											</span>
										</div>
									</th>
								);
							})}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row, i) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return (
										<td {...cell.getCellProps()}>
											<div className={classnames('text-' + cell.column.align)}>
												{cell.render('Cell')}
											</div>
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}

export default Table;
